if (!customElements.get('np-subscription-badge')) {
  customElements.define('np-subscription-badge', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const rates = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      const section = this.closest('.shopify-section');
      const update = (event) => {
        const id = event.detail?.variant?.id;
        if (!id || !Object.prototype.hasOwnProperty.call(rates, String(id))) return;
        if (section && event.target instanceof Node && !section.contains(event.target)) return;
        const badge = this.querySelector('.np-sub-widget__badge');
        const rate = Number(rates[id]);
        badge.textContent = `-${rate}%`;
        badge.style.display = rate > 0 ? '' : 'none';
      };
      // Listen on forms too: the theme's events need not cross shadow roots.
      const targets = new Set([section || document, ...(section?.querySelectorAll('form') || [])]);
      for (const target of targets) target.addEventListener('variant:change', update, {signal: this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
